export default "__VITE_ASSET__BnvMqILa__"